import {customFieldConstants} from '../constants/customfield.constants'

const initialState = {
  customFields: [],
  isLoading: false,
  shouldUpdate: false,
  showEditForm: false,
  newForm: {
    isLoading: false,
    postSuccess: false,
    postFail: false
  },
  editForm: {
    isLoading: false,
    postSuccess: false,
    postFail: false,
    name: '',
    title: '',
    value_type: ''
  }
}

export function CustomFieldReducer (state = initialState, action) {
  switch (action.type) {
    case (customFieldConstants.GETALL_REQUEST): {
      const updatedState = Object.assign({}, state, {
        shouldUpdate: false,
        isLoading: true
      })
      return updatedState
    }
    case (customFieldConstants.GETALL_SUCCESS): {
      const succesState = Object.assign({}, state, {
        isLoading: false,
        customFields: action.payload.customFields
      })
      return succesState
    }
    case (customFieldConstants.GETALL_FAILURE): {
      const updatedState = Object.assign({}, state, {
        isLoading: false
      })
      return updatedState
    }
    case (customFieldConstants.ADD_FIELD_REQUEST): {
      const newForm = Object.assign({}, state.newForm, {
        isLoading: true
      })
      const updatedState = Object.assign({}, state, {
        newForm: newForm
      })
      return updatedState
    }
    case (customFieldConstants.ADD_FIELD_SUCCESS): {
      const newForm = Object.assign({}, state.newForm, {
        isLoading: false,
        postSuccess: true,
        postFail: false
      })
      const updatedState = Object.assign({}, state, {
        shouldUpdate: true,
        newForm: newForm
      })
      return updatedState
    }
    case (customFieldConstants.ADD_FIELD_FAILURE): {
      const newForm = Object.assign({}, state.newForm, {
        isLoading: false,
        postSuccess: false,
        postFail: true
      })
      const updatedState = Object.assign({}, state, {
        newForm: newForm
      })
      return updatedState
    }
    // delete actions
    case (customFieldConstants.DELETE_CUSTOM_FIELD_REQUEST): {
      return state
    }
    case (customFieldConstants.DELETE_CUSTOM_FIELD_SUCCESS): {
      const updatedState = Object.assign({}, state, {
        shouldUpdate: true
      })
      return updatedState
    }
    case (customFieldConstants.DELETE_CUSTOM_FIELD_FAILURE): {
      return state
    }
    // get edit custom field details
    case (customFieldConstants.GET_EDIT_CUSTOM_FIELD_REQUEST): {
      const newState = Object.assign({}, state, {
        newForm: {
          isLoading: false,
          postSuccess: false,
          postFail: false
        }
      })
      return newState
    }
    case (customFieldConstants.GET_EDIT_CUSTOM_FIELD_SUCCESS): {
      const editForm = Object.assign({}, state.editForm, {
        ...action.payload.data.response
      })
      const updatedState = Object.assign({}, state, {
        showEditForm: true,
        editForm
      })
      return updatedState
    }
    case (customFieldConstants.GET_EDIT_CUSTOM_FIELD_FAILURE): {
      return state
    }
    // submit the edit form
    case (customFieldConstants.PUT_EDIT_CUSTOM_FIELD_REQUEST): {
      return state
    }
    case (customFieldConstants.PUT_EDIT_CUSTOM_FIELD_SUCCESS): {
      const updatedState = Object.assign({}, state, {
        shouldUpdate: true,
        showEditForm: false
      })
      return updatedState
    }
    case (customFieldConstants.PUT_EDIT_CUSTOM_FIELD_FAILURE): {
      return state
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/CustomFieldReducer.js